$(function () {
    $(".mobile-menu-trigger").on("click", function () {
        $(".top-menu-secondary").toggleClass("is-mobile-menu");
    });

    $(".search-option .left-option, .search-option .right-option").click(function() {
        if (!$(this).hasClass("active")) {
            let prefecture_translation = $("#prefecture-translation").text();
            $("#prefecture-button-name")
                .text(prefecture_translation)
                .attr("title", "")
                .removeClass("value-set");
            $("#prefecture-select-button .clear-icon").addClass("d-none");
            $("#prefecture-select-input").val("");

            let city_translation = $("#city-translation").text();
            $("#city-button-name")
                .text(city_translation)
                .attr("title", "")
                .removeClass("value-set");
            $("#city-select-button .clear-icon").addClass("d-none");
            $("#city-select-input").val("");
        }
    });

    $(".left-option").on("click", function () {
        $(".left-option").addClass("active");
        $(".right-option").removeClass("active");
        $(".search-input")
            .addClass("is_rent")
            .removeClass("is_sale");
        $(".search-building")
            .addClass("is_rent")
            .removeClass("is_sale");
        $("#is_rent").attr("checked", true);
        $("#region-select-modal .modal-header")
            .removeClass("is_sale")
            .addClass("is_rent");
        $(".region-modal .modal-header")
            .removeClass("is_sale")
            .addClass("is_rent");
        $("#city-select-modal .modal-header")
            .removeClass("is_sale")
            .addClass("is_rent");
    });

    $(".right-option").on("click", function () {
        $(".left-option").removeClass("active");
        $(".right-option").addClass("active");
        $(".search-input")
            .removeClass("is_rent")
            .addClass("is_sale");
        $(".search-building")
            .removeClass("is_rent")
            .addClass("is_sale");
        $("#is_sale").attr("checked", true);
        $("#region-select-modal .modal-header")
            .removeClass("is_rent")
            .addClass("is_sale");
        $(".region-modal .modal-header")
            .removeClass("is_rent")
            .addClass("is_sale");
        $("#city-select-modal .modal-header")
            .removeClass("is_rent")
            .addClass("is_sale");
    });
    
    $(".search-option .left-option, .search-option .right-option").click(function() {
        if ($(this).hasClass("active")) {
            let p_type = $(".search-option .left-option").hasClass("active") ? "rent" : "sale";
            let min_price_data = fetchPriceRangeData(p_type);
            max_price_data = min_price_data;
            
            let no_price = {
                "id": 0,
                "text": $("#not-specified-translation").text()
            };
            min_price_data.unshift(no_price);

            $("#min-price-select").empty().trigger("change");
            $("#min-price-select")
                .select2({
                    placeholder: $("#min-price-translation").text(),
                    allowClear: true,
                    minimumResultsForSearch: 5,
                    data: min_price_data,
                })
                .val("")
                .trigger("change");

            no_price = {
                "id": 99,
                "text": $("#not-specified-translation").text()
            };
            max_price_data.push(no_price);

            $("#max-price-select").empty().trigger("change");
            $("#max-price-select").select2({
                placeholder: $("#max-price-translation").text(),
                allowClear: true,
                minimumResultsForSearch: 5,
                data: max_price_data,
            })
            .val("")
            .trigger("change");

            reloadRegions();
        }
    });

    $("select.field-input").on("change", function () {
        // change color
        let sel_val = $(this).val();
        let is_sp = $(this).hasClass("is-sp");
        let this_id = $(this).attr("id");

        if (sel_val == "") {
            $(this).addClass("is_unselected");
            assigninput(this_id, is_sp, sel_val);
        } else {
            $(this).removeClass("is_unselected");
            assigninput(this_id, is_sp, sel_val);
        }
    });

    $("select.field-input").trigger("change");

    $("input.field-input").on("change", function () {
        let sel_val = $(this).val();
        let is_sp = $(this).hasClass("is-sp");
        let this_id = $(this).attr("id");
        if (is_sp) {
            this_id = this_id.replace("sp-", "");
            this_id = "#pc-" + this_id;
            $(this_id).val(sel_val);
        } else {
            this_id = this_id.replace("pc-", "");
            this_id = "#sp-" + this_id;
            $(this_id).val(sel_val);
        }
    });
    
    // sp and pc to have the same input
    function assigninput(this_id, is_sp, sel_val) {
        if (is_sp) {
            this_id = this_id.replace("sp-", "");
            this_id = "#pc-" + this_id;
            $(this_id).val(sel_val);
        } else {
            this_id = this_id.replace("pc-", "");
            this_id = "#sp-" + this_id;
            $(this_id).val(sel_val);
        }

        if (sel_val == "") {
            $(this_id).addClass("is_unselected");
        } else {
            $(this_id).removeClass("is_unselected");
        }
    }
});
